// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import { ProgressBarBrain } from '@/game/GameComponents/PhaserGame/UI/ProgressBarBrain';
import {
  getAnchorPlugin,
  waitForMilliseconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
/* END-USER-IMPORTS */

export default class ProgressBar extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.scaleX = 2;
    this.scaleY = 2;

    // barFrame
    const barFrame = scene.add.nineslice(
      0,
      0,
      'ProgressBarOutside',
      undefined,
      256,
      16,
      8,
      8,
      8,
      8,
    );
    barFrame.setOrigin(0, 0);
    this.add(barFrame);

    // barFill
    const barFill = scene.add.nineslice(
      0,
      0,
      'ProgressBarInsert',
      undefined,
      256,
      16,
      6,
      6,
      6,
      6,
    );
    barFill.setOrigin(0, 0);
    this.add(barFill);

    // barMask
    const barMask = scene.add.rectangle(0, 8, 320, 16);
    barMask.setOrigin(0, 0.5);
    barMask.alpha = 0;
    barMask.isFilled = true;
    this.add(barMask);

    this.barFrame = barFrame;
    this.barFill = barFill;
    this.barMask = barMask;

    /* START-USER-CTR-CODE */
    this.brain = new ProgressBarBrain(this);

    this.initializeResponsiveness();
    /* END-USER-CTR-CODE */
  }

  public barFrame: Phaser.GameObjects.NineSlice;
  public barFill: Phaser.GameObjects.NineSlice;
  public barMask: Phaser.GameObjects.Rectangle;

  /* START-USER-CODE */
  public brain: ProgressBarBrain;

  async initializeResponsiveness() {
    await waitForMilliseconds(this.scene.time, 1);

    ResponsivenessManager.MakeElementScaleDownWithGameSize(this, {
      ...DEFAULT_SCALE_DOWN_CONFIG,
      scaleModifier: this.scale,
    });

    ResponsivenessManager.InitializeResizeHandler(
      this.scene,
      () => this.handleResize(),
      this,
    );
  }

  async handleResize() {
    if (!this.scene || !this.scene.scene.isActive()) return;
    await waitForMilliseconds(this.scene.time, 1);
    const anchor = getAnchorPlugin(this.scene);
    const widthPercent = 50 / this.scaleX;

    anchor.add(this.barFill, {
      width: `${widthPercent}%`,
      left: '0%',
    });

    anchor.add(this.barFrame, {
      width: `${widthPercent}%`,
      left: '0%',
    });

    const maskWidth = widthPercent * this.brain?.CurrentProgress;
    anchor.add(this.barMask, {
      width: `${maskWidth}%`,
      left: '0%',
    });
  }

  destroy() {
    this.brain.destroy();

    super.destroy();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
